export const HOTKEYS = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline',
};

export const MAX_CHAR_COUNT_NAME = 35;
export const MAX_CHAR_COUNT_DESCRIPTION = 160;
export const MAX_CHAR_COUNT_RICH_TEXT = 10000;

export const DEFAULT_RICH_TEXT_CONTENT = '[{"children":[{"text":""}]}]';
export const DEFAULT_PERSON_LISTS_BY_DATE_CONTENT = {
  _onPresetSelectStep: true,
  _targetListIndex: 0,
};

export const RICH_TEXT_TYPE_ID = 'rich-text';
export const MY_TEAM_TYPE_ID = 'my-team';
export const PERSONS_LISTS_BY_DATE_TYPE_ID = 'person-lists-by-date';

export const WIDGET_NAME_FIELD_DESCRIPTION =
  'This name will appear at the top of the widget on the homepage.';

export const PREVIEW_PARAM_NAME = 'previewLayoutId';
